import { X } from 'lucide-react';

import { CustomInput, CustomSelectPicker, Loader } from '#/common/components';
import { FIELD_TYPES, MAX_LENGTH_LIMIT } from '#/utils/constants';
import { capitalizeText } from '#/utils/helperFunctions';
import { RenderFileList } from '..';

function LeadForm({
  lead,
  leadFormik,
  handleFileChange,
  handleTelInputChange,
  handleLeadFormClose,
  isFieldSubmit,
  isUploadFileLoading,
  isProcessingFiles,
  fileRef,
  uploadedFiles,
  color,
  textColor,
  handleRemoveFile,
  handleSelectChange,
  isLeadSubmitLoading,
}) {
  const isLoading = isUploadFileLoading || isProcessingFiles || isLeadSubmitLoading;

  return (
    <div className="chatbot-lead">
      <div className="head">
        <h4>{lead?.name}</h4>
        <span onClick={handleLeadFormClose}>
          <X />
        </span>
      </div>
      <form onSubmit={leadFormik.handleSubmit} className="fields">
        {lead?.fields?.map((field, index) => {
          if (!field?.label) return null;

          const { label, type, fieldItems = [], isRequired } = field;
          const fieldType = type?.toLowerCase();
          const isFileField = fieldType === FIELD_TYPES.UPLOAD;
          const isNumberField = fieldType === FIELD_TYPES.NUMBER;
          const isDropDownField = fieldType === FIELD_TYPES.DROPDOWN;
          const fieldError = leadFormik.errors?.[label] && leadFormik.touched?.[label];

          return (
            <div key={`${label}-${index}`} className="form-field">
              {isDropDownField ? (
                <CustomSelectPicker
                  name={label}
                  value={fieldItems.find(v => v.label === leadFormik.values?.[label])}
                  onChange={value => handleSelectChange(label, value?.label)}
                  options={fieldItems}
                  placeholder={capitalizeText(label)}
                  isError={fieldError}
                  errorMessage={leadFormik.errors?.[label]}
                  isRequired={isRequired}
                />
              ) : (
                <div className="field-wrapper">
                  <CustomInput
                    key={isFileField ? (isFieldSubmit ? 'uploaded' : 'empty') : label}
                    type={isFileField ? FIELD_TYPES.FILE : isNumberField ? FIELD_TYPES.TEL : fieldType}
                    name={label}
                    placeholder={isFileField && isProcessingFiles ? 'Uploading...' : capitalizeText(label)}
                    multiple={isFileField}
                    ref={fileRef}
                    isRequired={isRequired}
                    onChange={
                      isFileField
                        ? handleFileChange(label)
                        : isNumberField
                          ? handleTelInputChange(label)
                          : leadFormik.handleChange
                    }
                    maxLength={MAX_LENGTH_LIMIT}
                    value={isFileField ? undefined : leadFormik.values?.[label] || ''}
                    isError={fieldError}
                    errorMessage={leadFormik.errors?.[label]}
                    onKeyPress={
                      isNumberField
                        ? e => {
                          if (!/\d/.test(e.key)) {
                            e.preventDefault();
                          }
                        }
                        : undefined
                    }
                    disabled={isFileField && isProcessingFiles}
                  />
                  {isFileField && uploadedFiles?.[label] && (
                    <RenderFileList
                      files={uploadedFiles[label]}
                      fieldName={label}
                      handleRemoveFile={handleRemoveFile}
                    />
                  )}
                </div>
              )}
            </div>
          );
        })}
        <button
          type="submit"
          className="btn btn-primary"
          style={{ backgroundColor: color, color: textColor }}
          disabled={isLoading}
        >
          {isLeadSubmitLoading ? <Loader /> : lead?.submitButtonText}
        </button>
      </form>
    </div>
  );
}

export default LeadForm;
